export const ATTACHMENT_MIME_TYPE = {
  vcf: ['text/x-vcard', 'text/vcard'],
  text: ['text/plain'],
  image: ['image/jpg', 'image/jpeg', 'image/png', 'image/gif'],
  audio: [
    'audio/mp4',
    'audio/mpeg',
    'audio/3gpp',
    'audio/3gp2',
    'audio/3gpp2',
    'audio/ogg',
    'audio/aac',
    'audio/mpeg',
    'audio/wav',
    'audio/wave',
    'audio/webm'
  ],
  video: [
    'video/mp4',
    'video/mpeg',
    'video/3gpp',
    'video/3gp2',
    'video/3gpp2',
    'video/ogg',
    'video/quicktime',
    'video/webm'
  ]
};

export const DEFAULT_VCF_MIME_TYPE = ATTACHMENT_MIME_TYPE.vcf[0];

export const ATTACHMENT_MIME_TYPE_LIST = Object.values(ATTACHMENT_MIME_TYPE).flatMap(type => type);

export const MAX_SIZE_KB = {
  FILE: 592,
  TEXT: 8
};
